export const faceSwapeRoleOptions = {
    gender: {
      label: '性别',
      options: {
        man: '男性',
        woman: '女性'
      }
    },
    age: {
      label: '年龄',
      options: {
        baby: '婴儿 (0-2岁)',
        child: '儿童 (3-12岁)',
        teenager: '青少年 (13-19岁)',
        youngAdult: '青年 (20-39岁)',
        middleAged: '中年 (40-59岁)',
        senior: '老年 (60岁以上)'
      }
    },
    expression: {
      label: '表情',
      options: {
        happy: '开心',
        laughing: '大笑',
        serious: '严肃',
        calm: '平静',
        surprised: '惊讶',
        sad: '悲伤',
        angry: '愤怒',
        thoughtful: '沉思'
      }
    },
    eyeColor: {
      label: '眼睛颜色',
      options: {
        black: '黑色',
        brown: '棕色',
        blue: '蓝色',
        green: '绿色',
        gray: '灰色',
        hazel: '淡褐色'
      }
    },
    hairStyle: {
      label: '发型',
      options: {
        buzzCut: '寸头',
        crewCut: '平头',
        pixieCut: '精灵短发',
        bobCut: '波波头',
        shoulderLength: '齐肩发',
        longStraight: '长直发',
        longWavy: '长卷发',
        curly: '卷发',
        afro: '爆炸头',
        ponytail: '马尾',
        highBun: '高发髻',
        lowBun: '低发髻',
        bald: '光头'
      }
    },
    hairColor: {
      label: '发色',
      options: {
        black: '黑色',
        darkBrown: '深棕色',
        lightBrown: '浅棕色',
        blonde: '金色',
        platinumBlonde: '铂金色',
        red: '红色',
        auburn: '赤褐色',
        gray: '灰色',
        white: '白色',
        colorful: '彩色'
      }
    },
    beard: {
      label: '胡须',
      options: {
        cleanShaven: '干净剃须',
        fiveOClockShadow: '淡胡渣',
        lightStubble: '轻胡渣',
        heavyStubble: '重胡渣',
        goatee: '山羊胡',
        vanDyke: '范戴克胡',
        fullBeard: '络腮胡',
        handlebarMustache: '八字胡',
        pencilMustache: '铅笔胡'
      }
    },
    nationality: {
      label: '国籍',
      options: {
        afghan: '阿富汗人',
        albanian: '阿尔巴尼亚人',
        algerian: '阿尔及利亚人',
        american: '美国人',
        andorran: '安道尔人',
        angolan: '安哥拉人',
        argentine: '阿根廷人',
        armenian: '亚美尼亚人',
        australian: '澳大利亚人',
        austrian: '奥地利人',
        azerbaijani: '阿塞拜疆人',
        bahamian: '巴哈马人',
        bahraini: '巴林人',
        bangladeshi: '孟加拉人',
        barbadian: '巴巴多斯人',
        belarusian: '白俄罗斯人',
        belgian: '比利时人',
        belizean: '伯利兹人',
        beninese: '贝宁人',
        bhutanese: '不丹人',
        bolivian: '玻利维亚人',
        brazilian: '巴西人',
        british: '英国人',
        bruneian: '文莱人',
        bulgarian: '保加利亚人',
        burkinabe: '布基纳法索人',
        burundian: '布隆迪人',
        cambodian: '柬埔寨人',
        cameroonian: '喀麦隆人',
        canadian: '加拿大人',
        capeVerdian: '佛得角人',
        chadian: '乍得人',
        chilean: '智利人',
        chinese: '中国人',
        colombian: '哥伦比亚人',
        congolese: '刚果人',
        costaRican: '哥斯达黎加人',
        croatian: '克罗地亚人',
        cuban: '古巴人',
        cypriot: '塞浦路斯人',
        czech: '捷克人',
        danish: '丹麦人',
        dominican: '多米尼加人',
        dutch: '荷兰人',
        ecuadorean: '厄瓜多尔人',
        egyptian: '埃及人',
        emirian: '阿联酋人',
        estonian: '爱沙尼亚人',
        ethiopian: '埃塞俄比亚人',
        fijian: '斐济人',
        filipino: '菲律宾人',
        finnish: '芬兰人',
        french: '法国人',
        gabonese: '加蓬人',
        gambian: '冈比亚人',
        georgian: '格鲁吉亚人',
        german: '德国人',
        ghanaian: '加纳人',
        greek: '希腊人',
        guatemalan: '危地马拉人',
        guinean: '几内亚人',
        haitian: '海地人',
        honduran: '洪都拉斯人',
        hungarian: '匈牙利人',
        icelander: '冰岛人',
        indian: '印度人',
        indonesian: '印尼人',
        iranian: '伊朗人',
        iraqi: '伊拉克人',
        irish: '爱尔兰人',
        israeli: '以色列人',
        italian: '意大利人',
        ivorian: '科特迪瓦人',
        jamaican: '牙买加人',
        japanese: '日本人',
        jordanian: '约旦人',
        kazakhstani: '哈萨克人',
        kenyan: '肯尼亚人',
        northKorean: '朝鲜人',
        southKorean: '韩国人',
        kuwaiti: '科威特人',
        kyrgyz: '吉尔吉斯斯坦人',
        laotian: '老挝人',
        latvian: '拉脱维亚人',
        lebanese: '黎巴嫩人',
        liberian: '利比里亚人',
        libyan: '利比亚人',
        lithuanian: '立陶宛人',
        luxembourgish: '卢森堡人',
        macedonian: '马其顿人',
        malagasy: '马达加斯加人',
        malawian: '马拉维人',
        malaysian: '马来西亚人',
        maldivan: '马尔代夫人',
        malian: '马里人',
        maltese: '马耳他人',
        mauritanian: '毛里塔尼亚人',
        mauritian: '毛里求斯人',
        mexican: '墨西哥人',
        moldovan: '摩尔多瓦人',
        mongolian: '蒙古人',
        montenegrin: '黑山人',
        moroccan: '摩洛哥人',
        mozambican: '莫桑比克人',
        namibian: '纳米比亚人',
        nepalese: '尼泊尔人',
        newZealander: '新西兰人',
        nicaraguan: '尼加拉瓜人',
        nigerian: '尼日利亚人',
        norwegian: '挪威人',
        pakistani: '巴基斯坦人',
        panamanian: '巴拿马人',
        paraguayan: '巴拉圭人',
        peruvian: '秘鲁人',
        polish: '波兰人',
        portuguese: '葡萄牙人',
        qatari: '卡塔尔人',
        romanian: '罗马尼亚人',
        russian: '俄罗斯人',
        rwandan: '卢旺达人',
        salvadoran: '萨尔瓦多人',
        saudi: '沙特阿拉伯人',
        scottish: '苏格兰人',
        senegalese: '塞内加尔人',
        serbian: '塞尔维亚人',
        singaporean: '新加坡人',
        slovakian: '斯洛伐克人',
        slovenian: '斯洛文尼亚人',
        somali: '索马里人',
        southAfrican: '南非人',
        spanish: '西班牙人',
        sriLankan: '斯里兰卡人',
        sudanese: '苏丹人',
        swedish: '瑞典人',
        swiss: '瑞士人',
        syrian: '叙利亚人',
        thai: '泰国人',
        togolese: '多哥人',
        tunisian: '突尼斯人',
        turkish: '土耳其人',
        ugandan: '乌干达人',
        ukrainian: '乌克兰人',
        uruguayan: '乌拉圭人',
        uzbekistani: '乌兹别克斯坦人',
        venezuelan: '委内瑞拉人',
        vietnamese: '越南人',
        welsh: '威尔士人',
        yemeni: '也门人',
        zambian: '赞比亚人',
        zimbabwean: '津巴布韦人'
      }
    },
    bodyWeight: {
      label: '体重',
      options: {
        underweight: '体重过轻',
        normalWeight: '正常体重',
        overweight: '超重',
        obese: '肥胖'
      }
    },
    faceShape: {
      label: '脸型',
      options: {
        oval: '椭圆形',
        round: '圆形',
        square: '方形',
        heartShaped: '心形',
        long: '长形',
        rectangle: '矩形',
        triangle: '三角形',
        invertedTriangle: '倒三角形',
        pearShaped: '梨形',
        oblong: '长椭圆形'
      }
    },
    facialFeatureDetails: {
      label: '面部特征细节',
      options: {
        highNoseBridge: '高鼻梁',
        shortNose: '短鼻',
        largeEyes: '大眼睛',
        smallEyes: '小眼睛',
        highCheekbones: '高颧骨',
        smallMouth: '小嘴',
        fullLips: '丰满嘴唇',
        perfectTeeth: '完美牙齿',
        squint: '眯眼',
        naturalExpression: '自然表情'
      }
    },
    eyeFeatures: {
      label: '眼部特征',
      options: {
        doubleEyelids: '双眼皮',
        singleEyelids: '单眼皮',
        innerDoubleEyelids: '内双',
        deepSetEyes: '深邃眼睛',
        bagsUnderEyes: '眼袋',
        eyeshadowEffect: '眼影效果',
        eyeliner: '眼线'
      }
    },
    ears: {
      label: '耳朵',
      options: {
        visibleEars: '可见耳朵',
        hiddenEars: '隐藏耳朵',
        largeEars: '大耳朵',
        smallEars: '小耳朵',
        piercedEars: '穿耳洞',
        earrings: '耳环'
      }
    },
    skinDetails: {
      label: '皮肤细节',
      options: {
        smoothSkin: '光滑皮肤',
        spottedSkin: '斑点皮肤',
        dullSkin: '暗沉皮肤',
        healthyGlow: '健康光泽',
        naturalSkinTone: '自然肤色',
        acneFreckles: '痘痘/雀斑',
        wrinklesAgedLook: '皱纹/老化外观'
      }
    },
    skinTextureEffect: {
      label: '皮肤质感效果',
      options: {
        flawlessSkin: '无瑕皮肤',
        texturedSkin: '有质感皮肤',
        matteSkin: '哑光皮肤',
        glossySkin: '光泽皮肤',
        enhancedDetailTexture: '增强细节质感'
      }
    },
    clothingStyle: {
      label: '服装风格',
      options: {
        formalWear: '正式服装',
        suit: '西装',
        businessAttire: '商务装',
        eveningAttire: '晚礼服',
        casualWear: '休闲服装',
        sportswear: '运动服装',
        uniform: '制服',
        weddingAttire: '婚礼服',
        traditionalCostume: '传统服装',
        vintageRetroClothing: '复古/怀旧服装'
      }
    },
    clothingTexture: {
      label: '服装质感',
      options: {
        silkGlossyTexture: '丝绸/光泽质感',
        sweaterTexture: '毛衣质感',
        leatherTexture: '皮革质感',
        printedPattern: '印花图案',
        denimTexture: '牛仔质感'
      }
    },
    headAccessories: {
      label: '头部配饰',
      options: {
        hat: '帽子',
        glasses: '眼镜',
        jewelry: '珠宝',
        hairAccessories: '发饰',
        faceAccessories: '面部配饰'
      }
    }
  };
